import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AssetsFilterComponent } from './components/scripts/assetsFilter.component';
import { AssetsComponent } from './components/scripts/assets.component';
import { AuthGuard } from '../authentication/services/auth.guard.service';


const assetsRoutes: Routes = [
  {
    path: 'assets', component: AssetsFilterComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['Admin', 'MasterDataManager', 'MasterDataUser']
    },
    children: [
      {
        path: '',
        children: [
          {
            path: 'filter',
            component: AssetsFilterComponent,
            data: { preload: true }
          }
        ]
      }
    ]
  },
  {
    path: 'assets/edit/:assetId',
    component: AssetsComponent,
    data: {
      roles: ['Admin', 'MasterDataManager']
    },
  },
  {
    path: 'assets/create',
    component: AssetsComponent,
    data: {
      roles: ['Admin', 'MasterDataManager']
    },
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(assetsRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class AssetsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/assets/assets-routing.module.ts